import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { WEEK } from '@/Module/Core/Constant';
import { LAYOUT_API } from '@/Module/DefaultLayout/Constant';
import type { ICampaign } from '@/Module/DefaultLayout/Model';

export const CampaignQuery = createApi({
  reducerPath: 'campaignQuery',
  baseQuery: fetchBaseQuery({ baseUrl: 'unused' }),
  endpoints: builder => ({
    getCampaign: builder.query<ICampaign | { error: string }, void>({
      queryFn: async () => {
        try {
          const response = await fetch(LAYOUT_API.GET_CAMPAIGN);
          const data: ICampaign = await response.json();
          return { data };
        } catch (error) {
          return {
            error: { status: 'CUSTOM_ERROR', data: { error: (error as Error).message }, error: (error as Error).message },
          };
        }
      },
      keepUnusedDataFor: 2 * WEEK,
    }),
  }),
});

export const { useGetCampaignQuery } = CampaignQuery;
